import { Link } from 'react-router-dom';
import guardianLogo from '../assets/guardian-logo.svg';
import { LockIcon, ShieldCheckIcon } from './Icons.js';

export function Footer() {
  return (
    <footer className="footer">
      <div className="ft-container">

        {/* ── 4-Column Grid ── */}
        <div className="ft-grid">

          {/* Column 1 — Brand */}
          <div className="ft-col ft-brand">
            <Link to="/" className="ft-brand-link">
              <img src={guardianLogo} alt="" className="ft-brand-logo" aria-hidden="true" />
              <span className="ft-brand-name">CryptoGuardians</span>
            </Link>
            <p className="ft-brand-desc">
              CryptoGuardians helps protect MetaMask users from scams, malicious contracts, and wallet drain threats.
            </p>
            <div className="ft-brand-chips">
              <span className="ft-chip">Non-custodial</span>
              <span className="ft-chip">No fund access</span>
              <span className="ft-chip">Privacy-first</span>
            </div>
          </div>

          {/* Column 2 — Product */}
          <div className="ft-col">
            <h4 className="ft-col-title">Product</h4>
            <ul className="ft-link-list">
              <li><Link to="/wallet">Account Center</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/wallet">Install Snap</Link></li>
              <li><Link to="/support">Support</Link></li>
            </ul>
          </div>

          {/* Column 3 — Account & Recovery */}
          <div className="ft-col">
            <h4 className="ft-col-title">Account & Recovery</h4>
            <ul className="ft-link-list">
              <li><Link to="/recover">Restore Subscription</Link></li>
              <li><Link to="/transfer">Transfer Subscription</Link></li>
              <li><Link to="/support">Diagnostics</Link></li>
            </ul>
          </div>

          {/* Column 4 — Legal & Company */}
          <div className="ft-col">
            <h4 className="ft-col-title">Legal</h4>
            <ul className="ft-link-list">
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/disclaimer">Risk Disclaimer</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
              <li><Link to="/cancellation-policy">Cancellation Policy</Link></li>
              <li><Link to="/billing-policy">Billing Policy</Link></li>
              <li><Link to="/support">Contact</Link></li>
            </ul>
            <p className="ft-company">Operated by HAJ Solutions Inc</p>
          </div>
        </div>

        {/* ── Security Reassurance Bar ── */}
        <div className="ft-security-bar">
          <LockIcon className="ft-security-icon" aria-hidden="true" />
          <span>CryptoGuardians is non-custodial. We never access or control your funds.</span>
        </div>

        {/* ── SEO Text ── */}
        <p className="ft-seo">
          CryptoGuardians provides MetaMask security, smart contract scanning, and wallet drain protection tools.
        </p>

        {/* ── Copyright ── */}
        <div className="ft-bottom">
          <ShieldCheckIcon className="ft-bottom-icon" aria-hidden="true" />
          <span>&copy; {new Date().getFullYear()} CryptoGuardians. All rights reserved.</span>
        </div>

      </div>
    </footer>
  );
}
